import React, { useState } from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import "../../assets/Css/productdetail.css";
import { Link, useParams, useNavigate } from "react-router-dom";
import { detail, bene1, meter, play, modal1 } from "../../constant/Index";
import { useProductsGetByIdQuery } from "../../store/services/ProductsServices";
import currency from "currency-formatter";
import { useForm } from "./../../hooks/Form";
import ReactPlayer from "react-player";
import Spinner from "./../../utils/Loader";
import { useApplyInterestMutation } from "../../store/services/InterestService";
import { useDispatch, useSelector } from "react-redux";
import { setVechicle_ID } from "../../store/reducers/globalReducers";
import { useSiteSettingUrlQuery } from "../../store/services/SiteSettingServices";

const Productdetail = () => {
	const { data: ImageUrl, isFetching: ImageLoad } = useSiteSettingUrlQuery();
	const { userToken, user } = useSelector((state) => state.AuthReducer);
	let { id } = useParams();
	let [variantId, setVariantsId] = useState(null);
	let { state, onChange } = useForm({
		variants: "",
	});
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { data, isFetching } = useProductsGetByIdQuery(id);
	const [sendInterest, response] = useApplyInterestMutation();

	let ProductData = data?.response?.data;
	const setVariants = () => {
		setVariantsId(state?.variants);
	};

	const setInterestCard = (e) => {
		e.preventDefault();
		const FormDatas = new FormData();
		FormDatas.append("user_id", user?.id);
		FormDatas.append("vehicle_id", id);
		sendInterest(FormDatas);
	};

	return (
		<>
			{!isFetching ? (
				<>
					<Header />

					{/* Home and product sec  */}
					<section className="home-and-pro-sec">
						<div className="container">
							<div className="row">
								<div className="col-md-12">
									<div className="home-and-product">
										<p>
											<Link to="/">Home</Link>
											{">"}
											<Link to="/">Products detail</Link>
										</p>
									</div>
								</div>
							</div>
						</div>
					</section>

					{/* End of Home product sec  */}

					{/* Product detail section  */}
					<section className="product-detail-sec">
						<div className="container">
							<div className="row">
								<div className="col-lg-6 col-md-12">
									<div className="produtc-detail-img">
										<img
											className="img-fluid"
											src={`${ImageUrl?.uploads}${ProductData?.image}`}
										></img>
									</div>
								</div>

								<div className="col-lg-6  col-md-12 mt-4 mt-lg-0">
									<div className="product-detail-text">
										<div className="product-detail-head">
											<div className="product-de-he">
												<h3>{ProductData?.title}</h3>
												<p>{ProductData?.sub_title}</p>
											</div>
											<div className="product-price">
												<h3>
													<span>
														{ProductData?.price &&
															currency
																.format(ProductData?.price, {
																	code: "USD",
																})
																.split(".")[0]}
													</span>
												</h3>
											</div>
										</div>
										<div className="product-description">
											<h4>Description:</h4>
											<p>{ProductData?.description}</p>
										</div>

										<div className="product-description">
											<h4>Requirements:</h4>
											<ul>
												{ProductData?.requirements?.map((item, i) => {
													return <li>{item}</li>;
												})}
											</ul>
										</div>
									</div>

									<div className="row some-product-detail-row">
										<div className="col-md-6">
											<div className="fo-nam fo-colors">
												<span>
													<p>Colors:</p>
												</span>

												{/* <div className="color1 fill-color"> 
				  <div className="for-color-black"></div>
				</div>
				<div className="color2 fill-color"> </div>
				<div className="color3 fill-color"> </div>
				<div className="color4 fill-color"> </div> */}
												{ProductData?.colors?.map((col, index) => {
													return (
														<>
															<span
																className="cirlceStyle deatil_life_cycyle"
																style={{
																	background: `${col?.name.toLowerCase()}`,
																}}
															></span>
														</>
													);
												})}
												{/* <input className="black" type="radio" name="color"></input>
							<input
								className="white abcdefgh"
								type="radio"
								name="color"
							></input>
							<input className="red" type="radio" name="color"></input>
							<input className="blue" type="radio" name="color"></input> */}
											</div>
											<div className="product-deatil-btn mt-3">
												{!userToken ? (
													<button
														onClick={() => navigate("/login")}
														className="flit-btn"
													>
														<span className="for-txt">I am Interested</span>
														<span className="for-hover"></span>
													</button>
												) : (
													<button
														className="flit-btn"
														data-toggle="modal"
														data-target="#exampleModalCenter"
														onClick={setInterestCard}
													>
														<span className="for-txt">I am Interested</span>
														<span className="for-hover"></span>
													</button>
												)}
											</div>
										</div>

										<div className="col-md-6 mt-5 mt-lg-0 order-md-0">
											<div className="category-pic-text">
												<span className="spanss">Variants:</span>
												<div className="select-category">
													<select
														id="cars"
														name="variants"
														value={state?.variants}
														onChange={onChange}
														onClick={setVariants}
													>
														{ProductData?.variants?.map((item, index) => {
															return (
																<option key={item?.id} value={item?.name}>
																	{item?.name}
																</option>
															);
														})}
													</select>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>

					{/* End of Product detail section  */}
					{/* Inner banner heading  */}
					<section className="inner-banner">
						<div className="container">
							<div className="row">
								<div className="col-md-12">
									<div className="inner-banner-head ek">
										<h2>
											Features Of <span>{ProductData?.title}</span>
											<p>{ProductData?.description}</p>
										</h2>
									</div>
								</div>
							</div>

							<div className="row">
								<div className="col-md-4">
									<div className="img-all-car">
										<div className="img-car-pic">
											<figure>
												<img className="img-fluid" src={bene1}></img>
											</figure>
										</div>
										<h3>{ProductData?.range}</h3>
										<p>Max range</p>
									</div>
								</div>

								<div className="col-md-4">
									<div className="img-all-car">
										<div className="img-car-pic">
											<figure>
												<img className="img-fluid" src={bene1}></img>
											</figure>
										</div>
										<h3>{ProductData?.speed}</h3>
										<p>Max Speed throtle</p>
									</div>
								</div>

								<div className="col-md-4">
									<div className="img-all-car">
										<div className="img-car-pic">
											<figure>
												<img className="img-fluid" src={bene1}></img>
											</figure>
										</div>
										<h3>{ProductData?.battery}</h3>
										<p>1 Battery</p>
									</div>
								</div>
							</div>
						</div>
					</section>
					{/* End of Inner heading  */}

					{/* Inner banner heading  */}
					<section className="inner-banner">
						<div className="container">
							<div className="row">
								<div className="col-md-12">
									<div className="inner-banner-head horwin">
										<h2>
											Features Of <span>{ProductData?.title}</span>
											<p>{ProductData?.description}</p>
										</h2>
									</div>
								</div>
							</div>

							<div className="row">
								<div className="col-md-4">
									<div className="img-all-car">
										<div className="img-car-pic">
											<figure>
												<img className="img-fluid" src={bene1}></img>
											</figure>
										</div>
										<h3>{ProductData?.range}</h3>
										<p>Max range</p>
									</div>
								</div>

								<div className="col-md-4">
									<div className="img-all-car">
										<div className="img-car-pic">
											<figure>
												<img className="img-fluid" src={bene1}></img>
											</figure>
										</div>
										<h3>{ProductData?.speed}</h3>
										<p>Max Speed throtle</p>
									</div>
								</div>

								<div className="col-md-4">
									<div className="img-all-car">
										<div className="img-car-pic">
											<figure>
												<img className="img-fluid" src={bene1}></img>
											</figure>
										</div>
										<h3>{ProductData?.battery}</h3>
										<p>1 Battery</p>
									</div>
								</div>
							</div>
						</div>
					</section>
					{/* End of Inner heading  */}

					<section className="inner-banner">
						<div className="container">
							<div className="row">
								<div className="col-md-12">
									<div className="inner-banner-head horwin">
										<h2>
											Features Of <span>{ProductData?.title}</span>
											<p>{ProductData?.description}</p>
										</h2>
									</div>
								</div>
							</div>

							<div className="set_Video">
								<div className="row">
									<div className="col-md-12">
										<ReactPlayer
											width="100%"
											height="450px"
											controls={true}
											className="Set_Videoss"
											style={{ ObjectFit: "cover" }}
											url={ProductData?.video_link}
										/>
									</div>
								</div>
							</div>
						</div>
					</section>
					{/* End of Inner heading  */}

					<Footer />
					<div
						class="modal applyforloan_page fade"
						id="exampleModalCenter"
						tabindex="-1"
						role="dialog"
						aria-labelledby="exampleModalCenterTitle"
						aria-hidden="true"
					>
						<div class="modal-dialog apply-loan h-100" role="document">
							<div class="modal-content ">
								<div class="modal-body ">
									<div className="apply-loan h-100">
										<div className="row py-5">
											<div className="col-md-5  ">
												<div className="apply-loan-img">
													<img className="img-fluid" src={modal1}></img>
												</div>
											</div>

											<div className="col-md-6">
												<div className="modal-apply-loan-text">
													<h3>Would You Like To</h3>
													<h2>Apply for Loan</h2>
													<p>
														Vitae semper quis lectus nulla at volutpat diam ut.
														Adipiscing elit pellentesque habitant morbi
														tristique.{" "}
													</p>
													<div className="two-btns-apply-loan">
														<button
															className="bg-btn"
															style={{ cursor: "pointer" }}
															onClick={(e) => {
																e.preventDefault();
																dispatch(setVechicle_ID(id));
																localStorage.setItem("setVechicle_ID", id);
																window.location.href = "/applyforloan";
															}}
														>
															Yes
														</button>
														<button
															data-dismiss="modal"
															style={{ cursor: "pointer" }}
														>
															Not Now
														</button>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</>
			) : (
				<Spinner />
			)}
		</>
	);
};

export default Productdetail;
